import * as Utils from "../ts/rlAdmin.utils";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { ContractService } from "../services/contract-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { AdminConfigService } from "../services/admin-config-service";

export function RLFinancialTools() {
	var directive: ng.IDirective = {
		restrict: "E",
		controller: RLFinancialToolsController,
		controllerAs: "ftVM",
		bindToController: true,
		template: require("/assets/app/templates/financial-tools.html"),
		scope: {
			entityId: "<",
		}
	};

	return directive;
}

class RLFinancialToolsController {
    static $inject = ["$scope", "contractService", "eventService", "entityService", "adminConfigService"];

	entityId: string;
	canCalculateAllocation: boolean = false;
	calculateAllocationModalOpen: boolean = false;
	allocationType: number = 0;
	canCalculateAmortization: boolean = false;
	isCalculateAllocationModalLoaded: boolean = false;
    jobId: string;
	jobTitle: string;
	progressStatus: string;
    templates: Models.ICharacteristicTemplate[] = [];
    selectedTemplates: number[] = [];
    calculateAllocationOrAmortizationModalOpen: boolean = false;
    amortModels: Models.AmortizationModel[];
    selectedAllocationRows: string[];

    constructor(private $scope: ng.IScope, private contractService: ContractService, private eventService: EventService, private entityService: EntityService, private adminConfigService: AdminConfigService) {
		$scope.$on(Consts.Events.CanCalculateAllocation, () => this.canCalculateAllocation = true);
        $scope.$on(Consts.Events.CanCalculateAmortization, () => this.canCalculateAmortization = true);
        $scope.$on(Consts.Events.AllocationRowSelectionChanged, (event, rowIDs) => {
            this.selectedAllocationRows = rowIDs;
        });
        $scope.$watch(() => this.entityId, (newValue: string, oldValue: string) => {
            if (newValue != oldValue && newValue) {
                this.entityService.getEntityRecord(this.entityId).then(r => {
                    this.adminConfigService.getTemplateAmortizationModelAssociation(r.templateID).then(modelResult => {
                        this.adminConfigService.getAmortizationList().then(amortList => {
                            this.amortModels = _.select(amortList.data, (m) => _.contains(modelResult.data, m.id));
                            var straightLine: Models.AmortizationModel = {id:0,name:"Straight Line",numberOfPeriods:0,periods:[],recurrence:null};
                            this.amortModels.splice(0, 0, straightLine); //every deal is default associated to the straight line model
                        })
                    })
                });
            }
        }, true);
	}

	OpenCalculateAllocationModal() {
		this.calculateAllocationModalOpen = true;
		this.isCalculateAllocationModalLoaded = false;
		this.templates = [];

		this.entityService.getUsedTemplates(this.entityId, Consts.CharTypeIDs.property).then(templates => {
			this.templates = templates;
			this.isCalculateAllocationModalLoaded = true;
		});
	}

	ToggleSelection(templateId) {
		var index = this.selectedTemplates.indexOf(templateId);

		if (index > -1) {
			this.selectedTemplates.splice(index, 1);
		} else {
			this.selectedTemplates.push(templateId);
		}
	}

	IsSelectAllToggled() {
		return _.isEmpty(_.xor(this.templates.map(x => x.templateID), this.selectedTemplates));
	}

	ToggleSelectAll() {
		if (this.selectedTemplates.length < this.templates.length) {
			this.selectedTemplates = this.templates.map(x => x.templateID);
		} else {
			this.selectedTemplates = [];
		}
	}

	CalculateAllocation() {
		this.contractService.calculateAllocation(this.entityId, this.allocationType, this.selectedTemplates)
            .then((response) => {
                this.calculateAllocationModalOpen = false;
                this.jobId = response.jobID;
                this.jobTitle = response.jobTitle;
                this.calculateAllocationOrAmortizationModalOpen = true;
			});
	}

    CalculateAmortization(selectedModelId: number) {
        this.contractService.calculateAmortization(this.entityId, selectedModelId, this.selectedAllocationRows)
			.then((response) => {
				this.jobId = response.jobID;
				this.jobTitle = response.jobTitle;
                this.calculateAllocationOrAmortizationModalOpen = true;
			});
	}

    CalculateAllocationOrAmortizationComplete() {
		this.eventService.call(Consts.Events.RefreshTablesAndParents);

		if (this.jobTitle.indexOf("Allocation") >= 0) {
			this.calculateAllocationOrAmortizationModalOpen = false;
		}
	}
}